var Role;
(function (Role) {
    Role["ALERT"] = "alert";
    Role["BANNER"] = "banner";
    Role["BUTTON"] = "button";
    Role["COMBOBOX"] = "combobox";
    Role["DIALOG"] = "dialog";
    Role["GRID"] = "grid";
    Role["GRIDCELL"] = "gridcell";
    Role["GROUP"] = "group";
    Role["HEADING"] = "heading";
    Role["IMG"] = "img";
    Role["LIST"] = "list";
    Role["LISTBOX"] = "listbox";
    Role["MAIN"] = "main";
    Role["MENU"] = "menu";
    Role["MENUBAR"] = "menubar";
    Role["MENUITEM"] = "menuitem";
    Role["NAVIGATION"] = "navigation";
    Role["NONE"] = "none";
    Role["OPTION"] = "option";
    Role["PRESENTATION"] = "presentation";
    Role["RADIOGROUP"] = "radiogroup";
    Role["REGION"] = "region";
    Role["SEPARATOR"] = "separator";
    Role["SLIDER"] = "slider";
    Role["STATUS"] = "status";
    Role["TAB"] = "tab";
    Role["TABLIST"] = "tablist";
    Role["TOOLBAR"] = "toolbar";
    Role["TREE"] = "tree";
    Role["TREEITEM"] = "treeitem";
    Role["LINK"] = "link";
    Role["RADIO"] = "radio";
    Role["CHECKBOX"] = "checkbox";
    Role["LOG"] = "log";
})(Role || (Role = {}));

export { Role as R };
